import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAllInbox, MdClass, MdDownload, MdEmail, MdInbox, MdMail, MdMarkunreadMailbox, MdOutlineInbox, MdOutlineSettingsSuggest, MdSchool, MdSettings, MdSettingsAccessibility } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import TeacherProfile from "../components/TeacherProfile";
import { Dialog, DialogActions, DialogContent, Button } from "@mui/material";
import axios from "axios";
import { web_url } from "../../constant";

const url = "http://localhost:8080/api/";
function TeacherDashobardPageDesktop() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    const handleClose = () => { };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };


    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 1270) {
                navigate('/mobile/teacher/dashboard')
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        localStorage.removeItem('studentEmailForResetPassword');
    }, []);

    const [teacherName, setTeacherName] = useState('');
    const [teacherDistrict, setTeacherDistrict] = useState('');
    const [teacherSchool, setTeacherSchool] = useState('');
    const [teacherClass, setTeacherClass] = useState('');

    const [loadingValues, setLoadingValues] = useState(false);
    const [loadingPage, setLoadingPage] = useState(false);

    const [rStudents, setRStudents] = useState(0);
    const [pStudents, setPStudents] = useState(0);

    useEffect(() => {
        if (sessionStorage.getItem('greetings')) {
            const greetings = sessionStorage.getItem("greetings");
            if (greetings === 'true') {
                setLoadingPage(true);
                const getLogDetails = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails = getLogDetails();

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails.token}`,
                    },
                };

                const apiUrl = `${web_url}/api/auth/teachers/${logDetails.email}`
                axios.get(apiUrl, configToken)
                    .then((response) => {
                        // console.log(response.data);
                        localStorage.setItem('name', response.data.userFullName);
                        localStorage.setItem('district', response.data.district);
                        localStorage.setItem('school', response.data.school);
                        localStorage.setItem('assignedClass', response.data.assignedClass);
                        localStorage.setItem('mobile', response.data.contactNumber);
                        setTeacherName(response.data.userFullName);
                        setTeacherDistrict(response.data.district);
                        setTeacherSchool(response.data.school);
                        setTeacherClass(response.data.assignedClass);


                        setLoadingPage(false);
                        setOpen(true);
                    })
                    .catch((err) => {
                        console.log("error occured");
                    });
                sessionStorage.removeItem('greetings');
            }
            localStorage.setItem("refresh", `${Date.now()}`);
        } else {
            setTeacherName(localStorage.getItem('name'));
            setTeacherDistrict(localStorage.getItem('district'));
            setTeacherSchool(localStorage.getItem('school'));
            setTeacherClass(localStorage.getItem('assignedClass'));
            localStorage.setItem("refresh", `${Date.now()}`);
        }
    }, [])


    useEffect(() => {
        if (teacherName !== "") {

            setLoadingValues(true);
            const getLogDetails2 = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails2 = getLogDetails2();

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails2.token}`,
                },
            };
            const apiUrl = `${web_url}/api/auth/teachers/structure?userRole=STUDENT`
            axios.get(apiUrl, configToken)
                .then((response) => {
                    const district = response.data.find((d) => d.district === teacherDistrict);
                    const school = district?.schools.find((s) => s.school === teacherSchool);
                    const teacher = school?.teachers.find((t) => t.teacherName === teacherName && t.assignedClass === teacherClass);

                    if (!teacher || !teacher.students) {
                        setRStudents(0);
                        setPStudents(0);
                        setLoadingValues(false);
                        return;
                    }

                    const pendingStudents = teacher.students.filter(student => student.accountStatus === "PENDING").length;
                    const notPendingStudents = teacher.students.filter(student => student.accountStatus !== "PENDING").length;
                    setRStudents(notPendingStudents);
                    setPStudents(pendingStudents);
                    setLoadingValues(false);

                })
                .catch((err) => {
                    console.log("error occured", err);
                    setRStudents(0);
                    setPStudents(0);
                });
        }
    }, [localStorage.getItem('refresh'), teacherName, teacherClass])

    useEffect(() => {
        if (loadingPage) {
            setOpen2(true);
        } else {
            setOpen2(false);
        }
    }, [loadingPage])

    const [open2, setOpen2] = useState(false);


    useEffect(() => {

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const checkAuth = () => {
            const logDetails = getLogDetails();
            const currentTime = new Date();

            if (!logDetails) {
                alert("Please re-sign up to continue");
                localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            } else if (logDetails.category.toLowerCase() !== "teacher") {
                alert("Please re-sign up to continue");
                // localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            }

            if (sessionStorage.getItem('exp')) {
                if (new Date(sessionStorage.getItem('exp')) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                } else if (sessionStorage.getItem('exp') !== logDetails.exp) {
                    alert("Please re-sign up to continue");
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            } else {
                sessionStorage.setItem('exp', logDetails.exp);
                if (new Date(logDetails.exp) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            }
        };

        checkAuth(); // Run on mount

        const handleStorageChange = (event) => {
            if (event.key === "logDetails") {
                checkAuth(); // Re-check authentication if storage changes
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge bg-repeat bg-cover min-h-screen w-screen xl:pt-[50px]`}>
            <div className="xl:hidden absolute top-0 left-0 py-[25px] pl-[20px] md:pl-[30px] lg:pl-[40px]">
                <div className="flex justify-center items-center" >
                    <img className="h-[50px] md:h-[70px] lg:h-[90px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px]  font-semibold text-[16px] md:text-[20px] lg:text-[25px]">{t('t1')}</p>
                </div>
            </div>
            <Menu as="div" className="xl:hidden absolute top-0 right-0 text-left items-right py-[30px] md:py-[35px] pr-[20px] md:pr-[30px] lg:pr-[40px]">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
            <div className="rounded-md hidden xl:grid grid-cols-3 py-[5px] 2xl:py-[10px] bg-gradient-to-r from-[#FFA803] to-[#FFD12E] mx-[70px] px-[20px]">
                <div className="flex justify-start items-center">
                    <img className="h-[40px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px] font-semibold text-[20px]">{t('t1')}</p>
                </div>
                <div className="grid grid-cols-3 w-full">
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/home-w.svg" alt="home" onClick={() => navigate('/desktop/teacher/dashboard')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t410')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/mail-b.svg" alt="mail" onClick={() => {
                            const mailRequest = {
                                type: 'new',
                                subject: 'nothing'
                            };
                            localStorage.setItem('threadId', JSON.stringify(mailRequest));
                            navigate('/desktop/teacher/mailbox')
                        }} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t411')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/settings-b.svg" alt="settings" onClick={() => navigate('/desktop/teacher/settings')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t153')}
                        </span>
                    </div>
                </div>
                <div className="flex justify-end items-center">
                    <Menu as="div" className="text-left items-right">
                        <div>
                            <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                                {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                                <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                            </MenuButton>
                        </div>

                        <MenuItems
                            transition
                            className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                            <div className="py-1">
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("English");
                                            changeLanguage('en')
                                        }}
                                    >
                                        English
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Sinhala");
                                            changeLanguage('si')
                                        }}
                                    >
                                        සිංහල
                                    </button>
                                </MenuItem>
                                <MenuItem>
                                    <button
                                        className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                        onClick={() => {
                                            setLanguage("Tamil");
                                            changeLanguage('ta')
                                        }}
                                    >
                                        தமிழ்
                                    </button>
                                </MenuItem>
                            </div>
                        </MenuItems>
                    </Menu>
                </div>
            </div>
            <div className="grid grid-cols-7 w-full">
                <div className="col-span-4">
                    <div className="pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[30px] w-full">
                        <div className="bg-[#FDC50C] rounded-2xl ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-[160px] md:w-[210px] flex justify-center">
                            <p className="text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px] font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]">{t('t104')}</p>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 mt-[30px] xl:ml-[80px] xl:mr-[20px]">
                        <div className="flex flex-col justify-center items-center mr-[10px] lg:mr-[20px] xl:mr-[30px]">
                            <div className="bg-[#DDC69D] w-full flex justify-center rounded-t-xl h-[70px] items-center">
                                <p className="text-center text-[#695531] text-[15px] md:text-[16px] lg:text-[18px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px]">{t('t105')}</p>
                            </div>
                            <div className="bg-[#FEF2DC] w-full flex justify-center rounded-b-xl">
                                {
                                    loadingValues ?
                                        <div className="items-center justify-center flex p-3">
                                            <div className='w-10 h-10 border-2 border-t-transparent border-[#A07B00] rounded-full animate-spin'></div>
                                        </div> : <p className="text-[#A07B00] font-bold text-[40px] px-[20px] py-[10px]">{rStudents}</p>
                                }

                            </div>
                        </div>
                        <div className="flex flex-col justify-center items-center ml-[10px] lg:ml-[20px] xl:ml-[30px]">
                            <div className="bg-[#A1E0BB] w-full flex justify-center rounded-t-xl h-[70px] items-center">
                                <p className="text-center text-[#336C4B] text-[15px] md:text-[16px] lg:text-[18px] font-bold px-[20px] py-[10px] md:px-[25px] md:py-[15px] lg:px-[25px] lg:py-[15px] xl:px-[15px] xl:py-[15px]">{t('t106')}</p>
                            </div>
                            <div className="bg-[#DBFAE8] w-full flex justify-center rounded-b-xl">
                                {
                                    loadingValues ?
                                        <div className="items-center justify-center flex p-3">
                                            <div className='w-10 h-10 border-2 border-t-transparent border-[#336C4B] rounded-full animate-spin'></div>
                                        </div> : <p className="text-[#336C4B] font-bold text-[40px] px-[20px] py-[10px]">{pStudents}</p>
                                }

                            </div>
                        </div>
                    </div>
                    <div className="hidden xl:grid grid-cols-3 mt-[30px] 2xl:mt-[50px] ml-[90px] xl:gap-[5px]">
                        <div className="flex justify-center items-center mr-[20px] cursor-pointer h-[70px]" onClick={() => navigate('/teacher/managestudents')}>
                            <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                                <MdSettings size={30} color="#FDC50C" />
                            </div>
                            <div className="bg-[#FFEBA9] py-[20px] pl-[5px] pr-[8px] w-full rounded-r-lg h-full flex items-center">
                                <p className="text-black text-[15px] 2xl:text-[17px] font-bold">{t('t107')}</p>
                            </div>
                        </div>
                        <div className="flex justify-center items-center mr-[15px] cursor-pointer h-[70px]" onClick={() => navigate('/teacher/studentactivity')}>
                            <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                                <MdClass size={30} color="#FDC50C" />
                            </div>
                            <div className="bg-[#FFEBA9] py-[20px] pl-[10px] pr-[8px] w-full rounded-r-lg h-full flex items-center">
                                <p className="text-black text-[15px] 2xl:text-[17px] font-bold">{t('t108')}</p>
                            </div>
                        </div>
                        <div className="flex justify-center items-center mr-[20px] cursor-pointer h-[70px]" onClick={() => navigate('/desktop/teacher/mailbox')}>
                            <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                                <MdMail size={30} color="#FDC50C" />
                            </div>
                            <div className="bg-[#FFEBA9] py-[20px] pr-[8px] pl-[10px] w-full rounded-r-lg h-full flex items-center">
                                <p className="text-black text-[15px] 2xl:text-[17px] font-bold">{t('t109')}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-span-3">
                    <TeacherProfile t={t} />
                </div>
            </div>

            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className="flex flex-col justify-center items-center">
                            <p className="font-bold text-[15px] 2xl:text-[18px]">{t('t79')} {teacherName}</p>
                            <p className="pt-[20px] text-[15px] 2xl:text-[18px]">{t('t103')}</p>
                        </div>
                    </DialogContent>

                </DialogContent>
                <DialogActions
                    style={{
                        backgroundColor: '#FFF6DA',
                        display: 'flex',
                        justifyContent: 'center',
                        width: '100%',
                    }}
                >
                    <Button
                        disabled={loadingPage}
                        onClick={() => {
                            setOpen(false);
                        }}
                        style={{
                            margin: '0px 0px 10px 0px',
                            backgroundColor: '#F2AC0E',
                            color: 'white',
                            padding: '10px 20px', // px-4 py-2
                            borderRadius: '0.375rem', // rounded-md
                            fontWeight: 'bold',
                        }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open2}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className="items-center justify-center flex">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                    </DialogContent>

                </DialogContent>
            </Dialog>
        </div>
    )
}

export default TeacherDashobardPageDesktop;

